var _rect, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgColumnFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.747803,
    y: 0.15625,
    width: 20.8612,
    height: 23.625,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_4073_15445",
    transform: "matrix(0.0176951 0 0 0.015625 -0.0662438 0)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_4073_15445",
    width: 64,
    height: 64,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAHYAAAB2AH6XKZyAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAAAgtJREFUeJzt2r9qFVEQx/GPGkUbkWhioVaSTkUxRUoh+gixsE5tkcpGfAOx8AGMpZjGwk5sRYMaH0H8U4QgtlETi91wF8HdPd7kzlXnC4edvczs+c2Pu6fZIUmSJEmSJPk/2Tdk/STOY3oXtAzDJj7jNb6PYsMZrOAbtsdobeAOjuxd61zF1zFotm29wok+zZS+AjNYxdH6fg3L+NBSM4elOr6LFwX7LdX1cL0l7yDOYRFT9W/PMa8yZNdYMXD5fr1xFwuNmoXC/R41avswhXeNmjbTipk0eOff6Nc8ozUALqoOwm087UreX/DgC5io42WVGePIW9VrCpe7kksMON6IP5UoCmDnTJpqzVJmQDN3Vw+WPWCrvnYe8iUG/JOkAdECokkDogVEkwZEC4gmDYgWEE0aEC0gmjQgWkA0aUC0gGjSgGgB0aQB0QKiSQOiBUSTBkQLiCYNiBYQTRoQLSCaEgO2GvGws0V7zU5fnd8wSwzYaMSniuSMntP1db0rscSANYOZgBvG919wCbN1vNqWSJkBX/CkjmdxT/8pkVExjYc4UN8/6CqY6Er4hVu4phqSuokr9YbvW2rmfhP34UwjbhuvOaSaV1w0GOR4hseF+/Vi3viPyb3Uc0zuTzmrGmDaHINmm2sdt3G4byPDHmTHVMNTJ4d8zrBs4qNqeu1HsJYkSZIkSZLkr+Ani5Pe5AFABh8AAAAASUVORK5CYII="
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumnFilter);
export default __webpack_public_path__ + "static/media/Column Filter.44f83f0492b3d4a65d44b70efc479c73.svg";
export { ForwardRef as ReactComponent };